import {cleanFields} from '../../../utilities/helper/cleanFields';
import {toEnglishDigits} from '../../../utilities/helper/toEnglishNumber';
import request from '../../axios';

const PostPesticideAdvertisement = async (
  payload: IPesticideAdvertisementPayload,
) => {
  const newPayload = {
    ad_type: payload.ad_type,
    srs_type: payload.srs_type?.type,
    sub_input: payload.sub_input?.guid,
    title: payload.title,
    description: payload?.description || undefined,
    type: payload?.type?.value,
    ...(payload.price_on_call !== true && {ad_price: payload?.ad_price}),
    price_on_call: payload?.price_on_call || false,
    has_discount: payload?.has_discount || undefined,
    produce_year:
      payload?.produce_year && payload?.produce_year?.guid !== 'last'
        ? toEnglishDigits(payload?.produce_year?.title)
        : undefined,
    before_year: payload?.produce_year?.guid === 'last' ? 'True' : undefined,
    expire_year:
      payload?.produce_year?.guid !== 'last' &&
      payload?.produce_year &&
      payload?.expire_year
        ? (
            Number(payload?.expire_year?.guid) +
            Number(toEnglishDigits(payload?.produce_year?.title))
          ).toString()
        : undefined,
    producing_country: payload?.producing_country?.guid,
    profile_type: 'supplier',
    attributes: payload.attributes,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    only_massage_buyer: payload.only_massage_buyer || false,
    company: payload?.company,
    discount_amount: payload?.discount_amount || undefined,
    main_image: payload?.main_image,
    images: payload?.images?.length ? payload?.images : [],
    sub_brand_main_image: payload?.sub_brand_main_image,
    ...(payload?.sub_brand && {sub_brand: payload?.sub_brand}),
    sub_brand_images: payload?.sub_brand_images ?? [],
    quantity_pack: payload?.quantity_pack,
    quantity_pack_unit: payload?.quantity_pack_unit?.value,
    available_quantity: payload.available_quantity,
    min_sell_quantity: payload?.min_sell_quantity,
    application_method: payload?.application_method,
    combinations: payload?.combinations,
  };

  const cleanPayload = cleanFields(newPayload, [
    'main_image',
    'sub_brand_main_image',
  ]);

  const response = await request.post(
    `api/v2/store/pesticide-advertisement`,
    cleanPayload,
  );

  return response.data;
};

export default PostPesticideAdvertisement;
